import { useState } from "react";
import { Button } from "../design/components/Button";
import { Dialog } from "../design/components/Dialog";
import { TextField } from "../design/components/TextField";
import { useT } from "../i18n/locale";

type Props = { open: boolean; title: string; intro: string; link: string; onClose: () => void };

// Il link dell'invito da copiare quando l'email non è partita, perché il server non ha un provider o perché
// l'invio non è riuscito (piano M1b, decisione del controllore 2): dopo un invito e dopo un reinvio del Team, e
// per l'invito del titolare di un'azienda nuova (Task 11). La finestra è modale e rende inerte il resto della pagina, avvisi compresi (D16): l'esito di
// «Copia il link» si legge qui, in una riga `role="status"`.
export function ManualLinkDialog({ open, title, intro, link, onClose }: Props) {
  const t = useT();
  return (
    <Dialog open={open} title={title} onClose={onClose} footer={<Button onClick={onClose}>{t("common.close")}</Button>}>
      {/* Il corpo nasce a ogni apertura: «Copiato» non resta dalla volta prima. */}
      <ManualLinkBody intro={intro} link={link} />
    </Dialog>
  );
}

function ManualLinkBody({ intro, link }: { intro: string; link: string }) {
  const t = useT();
  const [copy, setCopy] = useState<"idle" | "copied" | "failed">("idle");

  async function copyLink() {
    try {
      await navigator.clipboard.writeText(link);
      setCopy("copied");
    } catch {
      // Appunti negati (permesso, pagina non sicura): il link resta nel campo, da copiare a mano.
      setCopy("failed");
    }
  }

  return (
    <>
      <p>{intro}</p>
      <TextField
        id="manual-link"
        label={t("manualLink.label")}
        value={link}
        readOnly
        // Un clic nel campo seleziona tutto il link, per copiarlo a mano se serve.
        onFocus={(event) => event.currentTarget.select()}
      />
      <div className="g-sheet__actions">
        <Button variant="primary" onClick={() => void copyLink()}>{t("manualLink.copy")}</Button>
        <p className="g-sheet__status" data-tone={copy === "failed" ? "warning" : undefined} role="status">
          {copy === "copied" ? t("manualLink.copied") : copy === "failed" ? t("manualLink.copyFailed") : null}
        </p>
      </div>
    </>
  );
}
